// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TagSpecial_wrapper__Yaj4L","tooltip":"TagSpecial_tooltip__Fdnyi"};